import { Grid, TextField, Button } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { SystemPageFilters } from './types';

interface Props {
  control: Control<SystemPageFilters>;
  clearFilters: () => void;
}

const WeatherFilter = ({ control, clearFilters }: Props) => {
  return (
    <>
      <Controller
        name='location'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='location'
              label='Filter By Location Name'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Controller
        name='dish'
        control={control}
        rules={{ required: true }}
        render={({ field: { onChange, value } }) => (
          <Grid item>
            <TextField
              name='dish'
              label='Filter By Dishes'
              variant='outlined'
              value={value}
              onChange={onChange}
            />
          </Grid>
        )}
      />
      <Grid item>
        <Button variant='contained' color='primary' onClick={clearFilters}>
          Clear Filters
        </Button>
      </Grid>
    </>
  );
};

export default WeatherFilter;
